import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../../service/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private api: ApiService, private routage: Router) { }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    var infos = await this.api.get_from_local_storage("infos")
    // console.log("infos = ", infos);
    if (infos != undefined && infos != null) {
      console.log("Utilisateur connecté")
      await this.api.update_infos()
      return true
    } else {
      console.log("Utilisateur non connecté")
      this.routage.navigate(['/public/login'], { queryParams: { returnUrl: state.url } });
      return false
    }
  }

}